module.exports = __webpack_public_path__ + "img/g.edb2d9e9.jpg";